import FieldMixins from './mixins/field_mixin.js';

export default Vue.extend({
  mixins: [FieldMixins],

  data() {
    return {
      type: 'datetime',
    };
  },

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               :disabledFieldLayout='disabledFieldLayout'
               ref='fieldView'>
      <Dropdown slot='optionbar'
                :optionGroups='_wrapDropdownOptions(optionbarContent)'
                :initValue='currentOption'
                :optionGroupsFixed='true'
                @change='changeType'>
        <template slot='value-template' slot-scope='{ option }'>
          <i :class='option.icon'></i>
          <span>{{ _getTypeTextOfField(option) }}</span>
        </template>
        <template slot='option-template' slot-scope='{ option }'>
          <i :class='option.icon'></i>
          <span>{{ _getTypeTextOfField(option) }}</span>
        </template>
      </Dropdown>
      <template slot='content'>
        <div class="edit-content" v-if='editing'>
          <div class='input-container inline'>
            <div class="input-control right-addon">
              <input type='text' :placeholder="'选择' + _getTypeText(field.settings.input_type)" readonly />
              <div class="addon">
                <i class='placeholder text-strong' :class='currentOption.icon'></i>
              </div>
            </div>
          </div>
        </div>
        <div class="display-content" v-else>
          <div class='input-container inline'>
            <div class="input-control right-addon">
              <input type='text' :placeholder="'选择' + _getTypeText(field.settings.input_type)" readonly />
              <div class="addon">
                <i class='placeholder text-strong' :class='currentOption.icon'></i>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="replaced-settings">
        <slot name="user-settings" :field="field"></slot>
      </template>
    </FieldView>
  `,
});
